import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IotReadingComponent } from './iot-reading/iot-reading.component';
import { ViewDetailsComponent } from './view-details/view-details.component';
import { EvReadingsComponent } from './ev-readings/ev-readings.component';

const routes: Routes = [
  { path: 'iotReading', component: IotReadingComponent },
  { path: 'evReadings', component: EvReadingsComponent },
  { path: 'iotReading/viewDetails', component: ViewDetailsComponent },
  { path: 'evReadings/viewDetails', component: ViewDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IotReadingRoutingModule {}
